import axios from 'axios';
import { del, get, post, put } from './api_helper';

const BASE_URL = process.env.REACT_APP_SERVER_URL + '/shofco/api/public/um/'

const getRegions = (data) => get(BASE_URL + 'region', data);

const getCounties = (data) => {
    return get(BASE_URL + 'county', { params: { regionId: 0, regionIds: data } });
};

const getSubCounties = (data) => {
    return get(BASE_URL + 'constituency', { params: { countyId: 0, countyIds: data } });
}

const getWards = (data) => get(BASE_URL + 'ward', { params: { constituencyId: 0, constituencyIds: data } });

export {
    getRegions,
    getCounties,
    getSubCounties,
    getWards
};